import { render, staticRenderFns } from "./DesktopSurveyUlasan.vue?vue&type=template&id=3cf350b1&scoped=true&"
import script from "./DesktopSurveyUlasan.vue?vue&type=script&lang=js&"
export * from "./DesktopSurveyUlasan.vue?vue&type=script&lang=js&"
import style0 from "./DesktopSurveyUlasan.vue?vue&type=style&index=0&id=3cf350b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf350b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
